import { render, staticRenderFns } from "./ServicesCard.vue?vue&type=template&id=44f6395e"
import script from "./ServicesCard.vue?vue&type=script&lang=js"
export * from "./ServicesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports